export interface Show {
  id: string;
  title: string;
  category: string;
  categorySlug: string;
  year: number;
  rating: number;
  episodes: number;
  status: string;
  description: string;
  cast: string[];
  director: string;
  genre: string[];
  image: string;
  updateInfo: string;
  featured: boolean;
}

export interface Category {
  name: string;
  slug: string;
  icon: string;
  description: string;
}

export const categories: Category[] = [
  { name: '韩剧', slug: 'korean', icon: 'ri-global-line', description: '最新最热韩剧，高分韩剧一网打尽' },
  { name: '国产剧', slug: 'chinese', icon: 'ri-building-2-line', description: '精品国产剧集，口碑好剧推荐' },
  { name: '美剧', slug: 'american', icon: 'ri-flag-2-line', description: '经典美剧系列，高分必看榜单' },
  { name: '日剧', slug: 'japanese', icon: 'ri-sun-line', description: '温暖治愈日剧，品质日剧推荐' },
];

export const shows: Show[] = [
  {
    id: 'show-1',
    title: '眼泪女王',
    category: '韩剧',
    categorySlug: 'korean',
    year: 2024,
    rating: 9.2,
    episodes: 16,
    status: '已完结',
    description: '该剧讲述了百货公司女王洪海仁与超市王子白贤宇结婚三年后，在面临离婚危机时意外发现彼此内心深处仍深爱着对方，经历了一系列啼笑皆非又感人至深的故事后重新找回爱情的浪漫喜剧。金秀贤与金智媛的精彩演绎让这部剧成为2024年最受瞩目的韩剧之一，剧情紧凑、笑中带泪，每一集都让观众欲罢不能。',
    cast: ['金秀贤', '金智媛', '朴成焄', '郭东延', '李主傧'],
    director: '金希元',
    genre: ['爱情', '喜剧', '剧情'],
    image: 'https://readdy.ai/api/search-image?query=A%20high-end%20Korean%20drama%20poster%20style%20with%20elegant%20couple%20in%20luxury%20fashion%2C%20warm%20golden%20and%20pastel%20color%20palette%2C%20cinematic%20lighting%2C%20romantic%20atmosphere%2C%20clean%20minimal%20background%20with%20soft%20gradient&width=600&height=800&seq=show-1&orientation=portrait',
    updateInfo: '2024年4月28日完结',
    featured: true,
  },
  {
    id: 'show-2',
    title: '狂飙',
    category: '国产剧',
    categorySlug: 'chinese',
    year: 2023,
    rating: 9.5,
    episodes: 39,
    status: '已完结',
    description: '该剧以一线刑警安欣与黑恶势力代表高启强长达二十年的正邪较量为主线，全景式展现了扫黑除恶的艰辛历程。张译、张颂文等实力派演员的精湛演技让每个角色都鲜活立体，剧情环环相扣、张力十足，被誉为近年来国产刑侦剧的巅峰之作。',
    cast: ['张译', '张颂文', '李一桐', '张志坚', '吴刚'],
    director: '徐纪周',
    genre: ['刑侦', '剧情', '犯罪'],
    image: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20poster%20with%20dark%20moody%20atmosphere%2C%20two%20men%20in%20confrontation%2C%20police%20and%20criminal%20theme%2C%20cinematic%20noir%20style%2C%20intense%20expression%2C%20simple%20dark%20gradient%20background&width=600&height=800&seq=show-2&orientation=portrait',
    updateInfo: '2023年2月1日完结',
    featured: true,
  },
  {
    id: 'show-3',
    title: '黑暗荣耀',
    category: '韩剧',
    categorySlug: 'korean',
    year: 2023,
    rating: 9.3,
    episodes: 16,
    status: '已完结',
    description: '该剧讲述了一个在高中时期遭受校园暴力后彻底崩溃的女孩文东恩，在多年后精心策划了一场对加害者的复仇计划。宋慧乔突破性的表演将复仇女神的冷峻与内心的脆弱完美呈现，剧本精妙、节奏紧凑，每一集都让人迫不及待想要看到下一集的反转。',
    cast: ['宋慧乔', '李到晛', '林智妍', '郑成日', '廉惠兰'],
    director: '安吉镐',
    genre: ['剧情', '复仇', '悬疑'],
    image: 'https://readdy.ai/api/search-image?query=Korean%20drama%20poster%20with%20dark%20elegant%20aesthetic%2C%20mysterious%20woman%20in%20black%2C%20revenge%20theme%2C%20cold%20and%20stylish%20atmosphere%2C%20minimal%20composition%2C%20soft%20dramatic%20lighting&width=600&height=800&seq=show-3&orientation=portrait',
    updateInfo: '2023年3月13日完结',
    featured: true,
  },
  {
    id: 'show-4',
    title: '漫长的季节',
    category: '国产剧',
    categorySlug: 'chinese',
    year: 2023,
    rating: 9.4,
    episodes: 12,
    status: '已完结',
    description: '以东北小城桦林为背景，讲述了一桩跨越近二十年的碎尸悬案如何改变了几个家庭和个人的命运。范伟、秦昊的精湛演绎让这部作品充满了东北黑土地特有的粗粝质感和深沉情感。导演辛爽用诗意的镜头语言和细腻的叙事节奏，打造了一部属于中国北方的黑色史诗。',
    cast: ['范伟', '秦昊', '陈明昊', '李庚希', '刘琳'],
    director: '辛爽',
    genre: ['悬疑', '剧情', '家庭'],
    image: 'https://readdy.ai/api/search-image?query=Chinese%20northern%20town%20mystery%20drama%20poster%2C%20rustic%20and%20nostalgic%20atmosphere%2C%20old%20factory%20town%20aesthetic%2C%20autumn%20colors%2C%20three%20men%20silhouette%2C%20warm%20but%20melancholic%20tone&width=600&height=800&seq=show-4&orientation=portrait',
    updateInfo: '2023年5月1日完结',
    featured: true,
  },
  {
    id: 'show-5',
    title: '爱的迫降',
    category: '韩剧',
    categorySlug: 'korean',
    year: 2019,
    rating: 9.0,
    episodes: 16,
    status: '已完结',
    description: '韩国财阀继承人尹世理在一次滑翔伞事故中意外降落到朝鲜，遇到了朝鲜军官李政赫，两人在跨越国界的奇妙相遇中逐渐产生了超越政治和意识形态的爱情。玄彬和孙艺珍的完美化学反应让这部剧成为韩剧经典之作，跨国恋情设定新颖独特，感人至深。',
    cast: ['玄彬', '孙艺珍', '徐智慧', '金正铉'],
    director: '李政孝',
    genre: ['爱情', '剧情', '喜剧'],
    image: 'https://readdy.ai/api/search-image?query=Korean%20romantic%20drama%20poster%20with%20elegant%20couple%2C%20soft%20and%20warm%20lighting%2C%20romantic%20atmosphere%2C%20beautiful%20scenery%20background%2C%20cinematic%20composition%2C%20pastel%20color%20tones&width=600&height=800&seq=show-5&orientation=portrait',
    updateInfo: '2020年2月16日完结',
    featured: false,
  },
  {
    id: 'show-6',
    title: '繁花',
    category: '国产剧',
    categorySlug: 'chinese',
    year: 2023,
    rating: 9.3,
    episodes: 30,
    status: '已完结',
    description: '改编自金宇澄同名小说，由王家卫执导的首部电视剧。故事围绕上海90年代改革开放浪潮中的阿宝展开，通过他的视角展现了那个充满机遇与挑战的大时代下，形形色色人物的命运浮沉。胡歌、马伊琍、唐嫣等主演的精彩演绎，加上王家卫独特的影像美学，让这部剧成为年度现象级作品。',
    cast: ['胡歌', '马伊琍', '唐嫣', '辛芷蕾', '游本昌'],
    director: '王家卫',
    genre: ['剧情', '年代', '爱情'],
    image: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20poster%20with%201990s%20Shanghai%20aesthetic%2C%20nostalgic%20golden%20lighting%2C%20elegant%20vintage%20style%2C%20sophisticated%20cityscape%20background%2C%20warm%20amber%20tone%2C%20cinematic%20composition&width=600&height=800&seq=show-6&orientation=portrait',
    updateInfo: '2024年1月9日完结',
    featured: true,
  },
  {
    id: 'show-7',
    title: '我的大叔',
    category: '韩剧',
    categorySlug: 'korean',
    year: 2018,
    rating: 9.4,
    episodes: 16,
    status: '已完结',
    description: '讲述了背负着生活重担却依然坚韧生活的三兄弟和一个同样在残酷现实中挣扎的年轻女子之间互相治愈的故事。IU与李善均的表演细腻入微，将普通人在生活压力下的脆弱与坚强刻画得淋漓尽致，被誉为韩剧史上最治愈人心的作品之一。',
    cast: ['李善均', 'IU', '高斗心', '宋清晨', '朴浩山'],
    director: '金元锡',
    genre: ['剧情', '治愈', '人生'],
    image: 'https://readdy.ai/api/search-image?query=Korean%20healing%20drama%20poster%2C%20warm%20and%20melancholic%20atmosphere%2C%20two%20people%20walking%20together%20at%20night%2C%20street%20lights%2C%20quiet%20and%20emotional%20mood%2C%20simple%20urban%20night%20background&width=600&height=800&seq=show-7&orientation=portrait',
    updateInfo: '2018年5月17日完结',
    featured: false,
  },
  {
    id: 'show-8',
    title: '绝命毒师',
    category: '美剧',
    categorySlug: 'american',
    year: 2008,
    rating: 9.7,
    episodes: 62,
    status: '已完结',
    description: '高中化学老师沃尔特·怀特在得知自己身患绝症后，为了给家人留下财产，利用自己的化学知识开始制造和贩卖冰毒，从此走上了一条不归路。布莱恩·科兰斯顿贡献了电视史上最伟大的表演之一，将一个普通人的黑化过程演绎得令人信服又震撼心灵。',
    cast: ['布莱恩·科兰斯顿', '亚伦·保尔', '安娜·冈', '迪恩·诺里斯'],
    director: '文斯·吉利根',
    genre: ['犯罪', '剧情', '惊悚'],
    image: 'https://readdy.ai/api/search-image?query=American%20crime%20drama%20poster%2C%20desert%20atmosphere%2C%20dark%20and%20intense%20mood%2C%20man%20in%20hazmat%20suit%20silhouette%2C%20cinematic%20lighting%2C%20warm%20desert%20color%20palette%2C%20minimal%20composition&width=600&height=800&seq=show-8&orientation=portrait',
    updateInfo: '2013年9月29日完结',
    featured: false,
  },
  {
    id: 'show-9',
    title: '权力的游戏',
    category: '美剧',
    categorySlug: 'american',
    year: 2011,
    rating: 9.5,
    episodes: 73,
    status: '已完结',
    description: '根据乔治·R·R·马丁的小说改编，讲述了维斯特洛大陆上各大家族为争夺铁王座而展开的权力斗争。宏大的世界观、复杂的人物关系、出人意料的剧情转折，让这部剧成为全球现象级的文化事件。龙、异鬼、战争与背叛交织成一幅波澜壮阔的史诗画卷。',
    cast: ['艾米莉亚·克拉克', '基特·哈灵顿', '彼特·丁拉基', '琳娜·海蒂'],
    director: '大卫·贝尼奥夫',
    genre: ['奇幻', '剧情', '冒险'],
    image: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20drama%20poster%2C%20iron%20throne%20theme%2C%20dark%20medieval%20atmosphere%2C%20dragon%20silhouette%2C%20dramatic%20cinematic%20lighting%2C%20dark%20and%20mysterious%20color%20palette%2C%20minimal%20composition&width=600&height=800&seq=show-9&orientation=portrait',
    updateInfo: '2019年5月19日完结',
    featured: false,
  },
  {
    id: 'show-10',
    title: '重启人生',
    category: '日剧',
    categorySlug: 'japanese',
    year: 2023,
    rating: 9.1,
    episodes: 10,
    status: '已完结',
    description: '33岁的普通公务员近藤麻美在一次意外中去世，来到死后世界后被告知下辈子将投胎成为大食蚁兽。为了在下一世投胎做人，她选择重新过一遍自己的人生，在反复重启中不断修正人生的选择。安藤樱的表演温暖治愈又充满幽默感，剧本构思巧妙、台词金句频出。',
    cast: ['安藤樱', '夏帆', '木南晴夏', '松坂桃李', '染谷将太'],
    director: '水野格',
    genre: ['喜剧', '奇幻', '治愈'],
    image: 'https://readdy.ai/api/search-image?query=Japanese%20comedy%20drama%20poster%2C%20warm%20and%20quirky%20atmosphere%2C%20everyday%20life%20scenes%2C%20soft%20natural%20lighting%2C%20pastel%20pastel%20colors%2C%20cozy%20cinematic%20style%2C%20simple%20Japanese%20aesthetic&width=600&height=800&seq=show-10&orientation=portrait',
    updateInfo: '2023年3月13日完结',
    featured: false,
  },
  {
    id: 'show-11',
    title: '半泽直树',
    category: '日剧',
    categorySlug: 'japanese',
    year: 2013,
    rating: 9.3,
    episodes: 20,
    status: '已完结',
    description: '银行职员半泽直树在职场中面对上司的欺压和不公时，以"加倍奉还"为信条，凭借智慧和勇气与银行内部的腐败势力展开了一场场精彩绝伦的斗争。堺雅人极具爆发力的表演和紧凑高能的剧情让这部剧创下了日本平成年间最高收视纪录。',
    cast: ['堺雅人', '上户彩', '香川照之', '及川光博', '片冈爱之助'],
    director: '福泽克雄',
    genre: ['职场', '剧情', '励志'],
    image: 'https://readdy.ai/api/search-image?query=Japanese%20business%20drama%20poster%2C%20corporate%20office%20theme%2C%20intense%20expression%2C%20banking%20atmosphere%2C%20dramatic%20lighting%2C%20sharp%20suit%20style%2C%20clean%20modern%20composition&width=600&height=800&seq=show-11&orientation=portrait',
    updateInfo: '2020年9月27日完结',
    featured: false,
  },
  {
    id: 'show-12',
    title: '去有风的地方',
    category: '国产剧',
    categorySlug: 'chinese',
    year: 2023,
    rating: 8.8,
    episodes: 40,
    status: '已完结',
    description: '五星级酒店前厅经理许红豆在挚友去世后陷入人生低谷，独自前往云南大理云苗村的有风小院休整。在这里她遇见了辞去高薪回乡创业的谢之遥，两个带着各自伤痕的人在大理的山水之间相互治愈、彼此温暖。刘亦菲和李现的自然演绎让这部剧成为治愈系国产剧的代表作。',
    cast: ['刘亦菲', '李现', '胡冰卿', '牛骏峰', '吴彦姝'],
    director: '丁梓光',
    genre: ['治愈', '爱情', '剧情'],
    image: 'https://readdy.ai/api/search-image?query=Chinese%20healing%20romantic%20drama%20poster%2C%20Yunnan%20Dali%20ancient%20town%20scenery%2C%20warm%20sunlight%2C%20peaceful%20countryside%2C%20natural%20green%20tones%2C%20gentle%20cinematic%20lighting%2C%20romantic%20atmosphere&width=600&height=800&seq=show-12&orientation=portrait',
    updateInfo: '2023年1月27日完结',
    featured: true,
  },
];

export const featuredShows = shows.filter(s => s.featured);

export function getShowById(id: string): Show | undefined {
  return shows.find(s => s.id === id);
}

export function getShowsByCategory(slug: string): Show[] {
  return shows.filter(s => s.categorySlug === slug);
}

export function getRelatedShows(show: Show, limit: number = 4): Show[] {
  return shows
    .filter(s => s.id !== show.id && (s.categorySlug === show.categorySlug || s.genre.some(g => show.genre.includes(g))))
    .slice(0, limit);
}

export const reviews = [
  {
    id: 'r1',
    name: '追剧达人小王',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20portrait%2C%20friendly%20smile%2C%20casual%20style%2C%20clean%20minimal%20background%2C%20warm%20lighting&width=80&height=80&seq=avatar-1&orientation=squarish',
    rating: 5,
    content: '琪琪影院真的太棒了！剧集更新快、分类清晰，自从用了这个网站追剧再也不用到处找了。韩剧和国产剧的资源特别全，画面也很清晰，强烈推荐给所有追剧党！',
    date: '2026年7月15日',
  },
  {
    id: 'r2',
    name: '韩剧迷小美',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%2C%20warm%20smile%2C%20natural%20look%2C%20clean%20minimal%20background%2C%20soft%20lighting&width=80&height=80&seq=avatar-2&orientation=squarish',
    rating: 5,
    content: '作为一名资深韩剧迷，琪琪影院是我每天必打开的网站。最新韩剧更新很快，而且分类做得很好，找起来特别方便。评分系统也很靠谱，帮我淘到了不少好剧！',
    date: '2026年7月10日',
  },
  {
    id: 'r3',
    name: '影视爱好者老张',
    avatar: 'https://readdy.ai/api/search-image?query=Middle%20aged%20Chinese%20man%20portrait%2C%20kind%20expression%2C%20simple%20style%2C%20clean%20minimal%20background%2C%20warm%20lighting&width=80&height=80&seq=avatar-3&orientation=squarish',
    rating: 5,
    content: '用了琪琪影院大半年了，体验一直很好。最让我惊喜的是剧集介绍特别详细，演员表、剧情简介都很完整。推荐功能也很智能，经常给我推一些我没想到但确实好看的剧。',
    date: '2026年6月28日',
  },
];

export const teamMembers = [
  {
    name: '陈琪琪',
    role: '创始人 & CEO',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20female%20professional%20portrait%2C%20modern%20business%20style%2C%20confident%20expression%2C%20clean%20minimal%20studio%20background%2C%20warm%20professional%20lighting&width=160&height=160&seq=team-1&orientation=squarish',
    bio: '资深影视行业从业者，拥有十年以上视频平台运营经验。热爱影视文化，致力于为中国观众打造最好的追剧体验。',
  },
  {
    name: '李铭远',
    role: '技术总监',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20male%20tech%20professional%20portrait%2C%20modern%20smart%20style%2C%20friendly%20expression%2C%20clean%20minimal%20studio%20background%2C%20warm%20professional%20lighting&width=160&height=160&seq=team-2&orientation=squarish',
    bio: '全栈工程师，专注于高性能流媒体技术架构。曾在多家互联网大厂担任技术负责人，带领团队打造稳定流畅的观影体验。',
  },
  {
    name: '王晓悦',
    role: '内容主编',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20female%20professional%20portrait%2C%20creative%20style%2C%20warm%20smile%2C%20clean%20minimal%20studio%20background%2C%20soft%20professional%20lighting&width=160&height=160&seq=team-3&orientation=squarish',
    bio: '影视专业硕士毕业，资深剧评人。负责平台内容策划与剧集推荐，以独到的眼光为用户筛选最值得观看的好剧。',
  },
];